import juristLogo from "@assets/images/logos/JuristAI.svg";
import juristMark from "@assets/images/logos/fedcrim-small-logo.svg";
import litigMark from "@assets/seasonal/litigai/logos/LitigAI-logo-icon.svg";
import seriesMark from "@assets/seasonal/seriesai/logos/seriesai-alone.svg";
import litigLogo from "@assets/seasonal/litigai/logos/LitigAI.svg";
import litigWhiteLogo from "@assets/seasonal/litigai/logos/LitigAI-white.svg";
import juristAuthBackground from "@assets/images/backgrounds/auth/auth-background.webp";
import seriesHero from "@assets/seasonal/seriesai/paintings/sisley-autumn-banks-of-the-seine-near-bougival.webp";
import litigHero from "@assets/seasonal/litigai/backgrounds/home-bg.webp";
import monetAutumn from "@assets/seasonal/seriesai/paintings/monet-autumn-on-the-seine-argenteuil.jpg";
import monetBeach from "@assets/seasonal/seriesai/paintings/monet-beach-sainte-adresse.jpg";
import monetCliff from "@assets/seasonal/seriesai/paintings/monet-cliff-walk-pourville.jpg";
import monetBordighera from "@assets/seasonal/seriesai/paintings/monet-bordighera.jpg";
import monetHaystacks from "@assets/seasonal/seriesai/paintings/monet-haystacks-sunset.png";
import monetParliament from "@assets/seasonal/seriesai/paintings/monet-houses-of-parliament-sunset.jpg";
import monetSunrise from "@assets/seasonal/seriesai/paintings/monet-impression-sunrise.jpg";
import monetPoppy from "@assets/seasonal/seriesai/paintings/monet-poppy-field-argenteuil.jpg";
import sisley from "@assets/seasonal/seriesai/paintings/sisley-autumn-banks-of-the-seine-near-bougival.webp";
import litigFile from "@assets/seasonal/litigai/backgrounds/file-organization-card-bg.jpg";
import litigScheduling from "@assets/seasonal/litigai/backgrounds/scheduling-card-bg.jpg";
import litigSignatures from "@assets/seasonal/litigai/backgrounds/signatures-card-bg.jpg";
import litigTimekeeping from "@assets/seasonal/litigai/backgrounds/timekeeping-card-bg.jpg";
import litigFirmVoice from "@assets/seasonal/litigai/backgrounds/firm-voice-drafting-bg.jpg";
import litigResearch from "@assets/seasonal/litigai/backgrounds/comprehensive-bg.jpg";
import litigContextualResearch from "@assets/seasonal/litigai/backgrounds/contextual-research-bg.png";
import litigCourt from "@assets/seasonal/litigai/backgrounds/court-section-bg.png";
import litigEmailWorkflow from "@assets/seasonal/litigai/backgrounds/email-workflow-bg.jpg";
import litigSecurity from "@assets/seasonal/litigai/backgrounds/security-compliance-bg.jpg";

export const SEASONS = Object.freeze({
  spring: "spring",
  summer: "summer",
  autumn: "autumn",
  winter: "winter",
});

export function getSeasonForMonth(month) {
  const normalizedMonth = Number(month);
  if (!Number.isInteger(normalizedMonth) || normalizedMonth < 0 || normalizedMonth > 11) {
    throw new RangeError("month must be an integer from 0 through 11");
  }
  if (normalizedMonth >= 2 && normalizedMonth <= 4) return SEASONS.spring;
  if (normalizedMonth >= 5 && normalizedMonth <= 7) return SEASONS.summer;
  if (normalizedMonth >= 8 && normalizedMonth <= 10) return SEASONS.autumn;
  return SEASONS.winter;
}

export function getCurrentSeason(date = new Date()) {
  const month = date.getMonth();
  const day = date.getDate();

  if ((month === 2 && day >= 20) || month === 3 || month === 4 || (month === 5 && day < 21)) {
    return SEASONS.spring;
  }
  if ((month === 5 && day >= 21) || month === 6 || month === 7 || (month === 8 && day < 22)) {
    return SEASONS.summer;
  }
  if ((month === 8 && day >= 22) || month === 9 || month === 10 || (month === 11 && day < 21)) {
    return SEASONS.autumn;
  }
  return SEASONS.winter;
}

function getPreviewSeason() {
  if (typeof window === "undefined") return null;
  const requestedSeason = new URLSearchParams(window.location.search).get("season");
  return Object.values(SEASONS).includes(requestedSeason) ? requestedSeason : null;
}

const currentPaintings = {
  capTable: monetAutumn,
  diligence: monetBeach,
  deadline: monetParliament,
  board: monetSunrise,
  project: monetPoppy,
  revenue: monetPoppy,
  round: monetHaystacks,
  safe: sisley,
};

const seriesPaintings = {
  capTable: monetAutumn,
  diligence: monetCliff,
  deadline: monetParliament,
  board: monetSunrise,
  project: monetBeach,
  revenue: monetPoppy,
  round: monetHaystacks,
  safe: sisley,
};

const litigPaintings = {
  court: litigCourt,
  contextualResearch: litigContextualResearch,
  emailWorkflow: litigEmailWorkflow,
  security: litigSecurity,
  comprehensive: litigResearch,
  capTable: litigFile,
  diligence: litigResearch,
  deadline: litigScheduling,
  board: litigSignatures,
  project: litigFirmVoice,
  revenue: litigTimekeeping,
  round: litigResearch,
  safe: litigFile,
};

const caseflowPaintings = {
  [SEASONS.spring]: [
    { id: "spring-beach", src: monetBeach, alt: "Spring shoreline painting" },
    { id: "spring-poppy", src: monetPoppy, alt: "Spring poppy field painting" },
    { id: "spring-sunrise", src: monetSunrise, alt: "Spring sunrise painting" },
  ],
  [SEASONS.summer]: [
    { id: "summer-cliff", src: monetCliff, alt: "Summer cliff walk painting" },
    { id: "summer-bordighera", src: monetBordighera, alt: "Summer garden painting" },
    { id: "summer-beach", src: monetBeach, alt: "Summer seaside painting" },
  ],
  [SEASONS.autumn]: [
    { id: "autumn-seine", src: monetAutumn, alt: "Autumn river painting" },
    { id: "autumn-sisley", src: sisley, alt: "Autumn riverside painting" },
    { id: "autumn-parliament", src: monetParliament, alt: "Autumn sunset painting" },
  ],
  [SEASONS.winter]: [
    { id: "winter-haystacks", src: monetHaystacks, alt: "Winter haystacks painting" },
    { id: "winter-sunrise", src: monetSunrise, alt: "Winter sunrise painting" },
    { id: "winter-parliament", src: monetParliament, alt: "Winter evening painting" },
  ],
};

export const SEASONAL_THEMES = Object.freeze({
  [SEASONS.spring]: {
    season: SEASONS.spring,
    brand: "juristai",
    logo: juristLogo,
    authLogo: juristLogo,
    mark: juristMark,
    heroImage: juristAuthBackground,
    authBackground: juristAuthBackground,
    visualOverlay: "linear-gradient(rgba(1, 7, 14, 0.35), rgba(0, 0, 0, 0.35))",
    authOverlay: "linear-gradient(rgba(1, 7, 14, 0.35), rgba(0, 0, 0, 0.35))",
    paintings: currentPaintings,
    caseflowPaintings: caseflowPaintings[SEASONS.spring],
  },
  [SEASONS.summer]: {
    season: SEASONS.summer,
    brand: "juristai",
    logo: juristLogo,
    authLogo: juristLogo,
    mark: juristMark,
    heroImage: juristAuthBackground,
    authBackground: juristAuthBackground,
    visualOverlay: "linear-gradient(rgba(1, 7, 14, 0.35), rgba(0, 0, 0, 0.35))",
    authOverlay: "linear-gradient(rgba(1, 7, 14, 0.35), rgba(0, 0, 0, 0.35))",
    paintings: currentPaintings,
    caseflowPaintings: caseflowPaintings[SEASONS.summer],
  },
  [SEASONS.autumn]: {
    season: SEASONS.autumn,
    brand: "seriesai",
    mark: seriesMark,
    heroImage: seriesHero,
    authBackground: seriesHero,
    visualOverlay: "linear-gradient(rgba(69, 26, 3, 0.22), rgba(69, 26, 3, 0.22))",
    authOverlay: "linear-gradient(rgba(69, 26, 3, 0.35), rgba(69, 26, 3, 0.35))",
    paintings: seriesPaintings,
    caseflowPaintings: caseflowPaintings[SEASONS.autumn],
  },
  [SEASONS.winter]: {
    season: SEASONS.winter,
    brand: "litigai",
    logo: litigLogo,
    authLogo: litigWhiteLogo,
    mark: litigMark,
    heroImage: litigHero,
    authBackground: litigHero,
    visualOverlay: "linear-gradient(rgba(15, 23, 42, 0.22), rgba(15, 23, 42, 0.22))",
    authOverlay: "linear-gradient(rgba(15, 23, 42, 0.22), rgba(15, 23, 42, 0.22))",
    paintings: litigPaintings,
    caseflowPaintings: caseflowPaintings[SEASONS.winter],
  },
});

export function getSeasonalTheme(date) {
  const season = date ? getCurrentSeason(date) : getPreviewSeason() || getCurrentSeason();
  return SEASONAL_THEMES[season];
}

// Must run before the first React render: applying this in an effect paints one
// frame of the default (spring/summer) palette before the season swaps in.
export function applySeasonalTheme() {
  const theme = getSeasonalTheme();
  const root = document.documentElement;
  let heroPreload = document.head.querySelector('link[data-seasonal-hero-preload="true"]');
  if (!heroPreload) {
    heroPreload = document.createElement("link");
    heroPreload.rel = "preload";
    heroPreload.as = "image";
    heroPreload.dataset.seasonalHeroPreload = "true";
    document.head.appendChild(heroPreload);
  }
  heroPreload.href = theme.heroImage;
  heroPreload.setAttribute("fetchpriority", "high");
  root.dataset.season = theme.season;
  root.style.setProperty("--season-hero-image", `url("${theme.heroImage}")`);
  root.style.setProperty("--season-auth-background", `url("${theme.authBackground}")`);
  root.style.setProperty("--season-visual-overlay", theme.visualOverlay);
  root.style.setProperty("--season-auth-overlay", theme.authOverlay || theme.visualOverlay);
  Object.entries(theme.paintings || {}).forEach(([name, image]) => {
    root.style.setProperty(`--season-painting-${name}`, `url("${image}")`);
  });
  return theme;
}
